function get_custom_field_option_editor(custom_field_id, show_editor) {
  var show_editor_param = "";

  if (show_editor) {
    show_editor_param = "&show_editor=1";
  }

  $.get("/app/?module=forms&page=field_option_editor&nohtml=1&cf_id=" + custom_field_id + show_editor_param, function (data) {
    $('#option_editor_for_' + custom_field_id).html(data);
  });
}

function toggle_option_editor(cf_id, mode) {
  set_field_use_options(cf_id, mode);

  if (mode > 0) {
    $('#option_editor_for_' + cf_id).slideDown();
  } else {
    $('#option_editor_for_' + cf_id).slideUp();
  }
}

function fill_in_option_editors() {
  $(".option-editor-container").each(function () {
    var cf_id = $(this).attr('for_field');
    get_custom_field_option_editor(cf_id, false);
  });
}

function set_field_use_options(custom_field_id, use_options) {
  $.get('/app/?module=forms&actn=set_field_use_selection&cf_id=' + custom_field_id + '&use_selection=' + use_options);
}

function add_option_to_field_form_submit(custom_field_id) {
  var label = $('#new_label_for_' + custom_field_id).val();
  var value = $('#new_value_for_' + custom_field_id).val();

  $.get('/app/?module=forms&actn=add_field_option&cf_id=' + custom_field_id + '&label=' + encodeURI(label) + '&value=' + encodeURI(value), function () {
    get_custom_field_option_editor(custom_field_id, true);
  });
}

function delete_field_option(custom_field_id, weight) {
  if (confirm('Are you sure you want to delete this option?')) {
    $.get('/app/?module=forms&actn=delete_field_option&cf_id=' + custom_field_id + '&weight=' + encodeURI(weight), function () {
      get_custom_field_option_editor(custom_field_id, true);
    });
  }
}

function edit_field_option(custom_field_id, weight) {
  var label = $('#editable_label_for_' + custom_field_id + '_' + weight).val();
  var value = $('#editable_value_for_' + custom_field_id + '_' + weight).val();

  $.get('/app/?module=forms&actn=edit_field_option&cf_id=' + custom_field_id + '&label=' + encodeURI(label) + '&value=' + encodeURI(value) + '&weight=' + weight, function () {
    get_custom_field_option_editor(custom_field_id, true);
  });
}

function delete_custom_field(custom_field_id) {
  if (confirm('DANGER: Are you sure you want to completely delete this field? If its used on any forms, it will remove this field from those forms.')) {
    $.get('/app/?module=forms&actn=delete_custom_field&cf_id=' + custom_field_id, function () {
      window.location.href = window.location.href;
    });
  }
}

function get_form_fields_editor(form_id) {
  $.get("/app/?module=forms&page=field_list_editor&nohtml=1&form_id=" + form_id, function (data) {

    try {
      $('#field_editor_container').html(data);
    } catch(e) {
      void (0); //flash sometimes throws some noise, and we don't care, carry on
    }

    $('#field_editor_container').sortable({
      item:  'div.field_wrapper',
      handle:  '.field_sort_handle',
      containment: 'parent',
      update: function (event, ui) {
        submit_reordered_fields();
      }
    });

    fill_in_option_editors();
    reload_form_preview();

    if ($('.bb-video-recorder-container').length > 0) {
      $('#recorderOptions').slideDown();
      $('#addRecorderButton').slideUp();
    } else {
      $('#recorderOptions').slideUp();
      $('#addRecorderButton').slideDown();
    }
  });
}

function add_field_to_form(form_id, field_id, html, list_id, is_video_recorder) {
  $.post("/app/?module=forms&actn=add_field_to_form&form_id=" + form_id + "&field_id=" + field_id, {html: html, list_id: list_id, is_video_recorder: is_video_recorder}, function (data) {
    get_form_fields_editor(form_id);
  });
}

function remove_field_from_form(form_id, form_field_id) {
  if (confirm('Really Remove Field from Form?')) {
    $.post("/app/?module=forms&actn=remove_field_from_form&form_id=" + form_id + "&form_field_id=" + form_field_id, function (data) {
      get_form_fields_editor(form_id);
    });
  }
}

function submit_reordered_fields() {

  var field_list = "";

  $('#field_editor_container').children().each(function () {
    var field_id = $(this).attr('form_field_id');
    field_list = field_list + ',' + field_id;
  });

  if (field_list != "") {
    field_list = field_list.substring(1); //remove leading comma
  }

  $.post("/app/?module=forms&actn=reorder_fields_from_ordered_array", {ordered_ids: field_list});
}

function create_field_and_add_to_form(form_id) {

  var label = $('#new_field_name').val();
  var type = $('#new_field_type').val();

  if ($.trim(label) == '') {
    alert('Please enter a name for your new field.');
    return;
  }

  $.post("/app/?module=forms&actn=add_custom_field&add_to_form=" + form_id, {field_name: label, field_type: type}, function () {
    get_form_fields_editor(form_id);
    $('#new_field_name').val('');
  });
}

var active_ckeditor_for_html_field = null;
function show_form_field_editor(form_id, field_id) {

  hide_all_field_editors();

  $('#field_preview_for_' + field_id).hide();
  $('#field_editor_for_' + field_id).fadeIn();

  if ($('#html_editor_for_field_' + field_id).length) {
    active_ckeditor_for_html_field = 'html_editor_for_field_' + field_id;
    boot_ckeditor_for_html_field(field_id);
  }
}

function hide_all_field_editors() {
  $('.field_editor').hide();
  $('.field_preview').show();
}

function field_formater_changed(form_field_id, contact_field_id) {
  //get the mode from the select box
  var mode = 0;

  $('#formatter_for_' + form_field_id).children(":selected").each(function () {
    mode = $(this).attr('select_mode');
  });

  toggle_option_editor(contact_field_id, mode);
}

function save_form_field(form_field_id) {
  //if it's an html field, catch it and save it, otherwise, proceed to save a regular field
  if ($('#html_editor_for_field_' + form_field_id).length) {
    var html = CKEDITOR.instances['html_editor_for_field_' + form_field_id].getData();

    $.post('/app/?module=forms&actn=save_form_field_html', {form_field_id: form_field_id, html: html}, function () {
      get_form_fields_editor(form_id);
    });

    return;
  }

  var label = $('#label_for_field_' + form_field_id).val();
  var hint = $('#hint_for_field_' + form_field_id).val();
  var required = ($('#required_for_field_' + form_field_id).is(":checked")) ? 1 : 0;
  var formatter = $('#formatter_for_' + form_field_id).val();
  var list_label = $('#list_label_for_field_id_' + form_field_id).val();

  if (formatter == 'undefined') {
    formatter = '';
  }

  var arr = {
    form_field_id: form_field_id,
    label: label,
    hint: hint,
    required: required,
    formatter: formatter,
    list_label: list_label
  };

  $.post('/app/?module=forms&actn=save_form_field_ui_choices', arr, function () {
    get_form_fields_editor(form_id);
  });
}

var bb_mini_toolbar = [
  { name: 'clipboard', items : [ 'Undo','Redo' ] },
  { name: 'basicstyles', items : [ 'Bold','Italic' ] },
  { name: 'paragraph', items : [ 'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'] },
  { name: 'links', items : [ 'Link','Unlink'] },
  { name: 'insert', items : [ 'HorizontalRule' ] },
  { name: 'styles', items : [ 'Format','FontSize' ] },
  { name: 'colors', items : [ 'TextColor' ] },
  { name: 'document', items : [ 'Source' ] }
];

function boot_ckeditor_for_html_field(form_field_id) {
  var textarea_id = 'html_editor_for_field_' + form_field_id;

  //kill any existing editors by the same name
  var editor = CKEDITOR.instances[textarea_id];
  try {
    if (editor) {
      editor.destroy(true);
    }
  } catch(Exc) {
  }

  try {
    delete CKEDITOR.instances[textarea_id];
  } catch(Exc) {
  }

  CKEDITOR.replace(textarea_id, {
    height:220,
    uiColor: 'white',
    toolbar: bb_mini_toolbar,
    removePlugins: 'elementspath'
  });
}

function save_form_options() {
  $('#response_html').val(CKEDITOR.instances['response_html'].getData());

  el('redirect_url').value = prependHTTPtoWebURL(el('redirect_url').value);

  var arr = $('#form_options').serialize();
  $.post('/app/?module=forms&actn=save_form_options', arr, function () {
    $.notify.success('Saved!');
  });
}

function add_auto_entity_to_form(entity_name, entity_id) {
  $.post('/app/?module=forms&actn=add_auto_entity_to_form', {form_id: form_id, entity_name: entity_name, entity_id: entity_id}, function () {
    refresh_auto_entity_list(entity_name);
  });
}

function remove_auto_entity_from_form(entity_name, entity_id) {
  $.post('/app/?module=forms&actn=remove_auto_entity_from_form', {form_id: form_id, entity_name: entity_name, entity_id: entity_id}, function () {
    refresh_auto_entity_list(entity_name);
  });
}

function refresh_auto_entity_list(entity_name) {
  $.post('/app/?module=forms&actn=get_auto_feature_list', {form_id: form_id, entity_name: entity_name}, function (data) {
    var thingies = $.parseJSON(data);

    var container = $(".form_auto_feature_container[entity_name='" + entity_name + "']");
    $(container).empty();

    $(thingies).each(function () {
      $(container).append($("<li>" + this.name + " - <a href='javascript:void(0)' onclick='remove_auto_entity_from_form(\"" + entity_name + "\", \"" + this.id + "\")'>delete</a></li>"));
    });
  });
}

function save_theme_css() {
  $.post('/app/?module=forms&actn=save_theme_css', {form_id: form_id, theme_name: $('input:radio[name=form_theme]:checked').val(), css: $('#theme_css').val()}, function (data) {
    reload_form_preview();
    $.notify.success('Form theme saved.', 'theme-saved');
  });
}

function form_theme_changed() {

  save_theme_css();

  var val = $('input:radio[name=form_theme]:checked').val();

  if (val == 'custom') {
    $('#custom_theme_controls').slideDown();
  } else {
    $('#custom_theme_controls').slideUp();
  }
}

function reload_form_preview() {
  refresh_form_thumb(form_id);
  $('#theme_preview').attr('src', $('#theme_preview').attr('src'));
}

var auto_validate_onchange = false;
function bb_field_changed(sender) {
  if (auto_validate_onchange) {
    if (validate_bb_form()) {
      show_form_message("", true);
    }
  }
}

function toggleCheckboxOrRadioButtonValue(sender) {
  if (sender) {
    if (sender.type == "checkbox" || sender.type == "radio") {
      if (!sender.checked) {
        sender.value = "";
      } else {
        if (sender.attributes['data-option-value']) {
          sender.value = sender.attributes['data-option-value'].value;
        }
      }
    }
  }
}

var bb_form_values = {};
function compile_bb_form_values(field_class_name) {
  var captcha = undefined;
  if (bb_form_values) {
    captcha = bb_form_values['g-recaptcha'];
  }
  bb_form_values = {};

  if (captcha) {
    bb_form_values['g-recaptcha-required'] = true;
    bb_form_values['g-recaptcha'] = captcha;
  } else {
    bb_form_values['g-recaptcha-required'] = false;
  }

  if (field_class_name == undefined) {
    field_class_name = 'form_field';
  }

  bb_form_values['__form_id'] = bb_form_id;

  if (typeof vidFilename != 'undefined') {
    if (vidFilename != '') {
      bb_form_values['__vid_id'] = vidId;
    }
  }

  //get the txt inputs
  $('.' + field_class_name).each(function () {
    bb_form_values[$(this).attr('id')] = $(this).val();
  });

  //get the cbl/rbl inputs
  $('.bb_check, .bb_radio').each(function () {
    var existing_val = bb_form_values[$(this).attr('field_id')] || '';

    if (this.checked) {
      var val = $(this).val();

      if (existing_val.length > 0) {
        existing_val += ',' + val;
      } else {
        existing_val = val;
      }
    }

    bb_form_values[$(this).attr('field_id')] = existing_val;
  });

  //get the selected subscriptions
  $('.list_sub_check:checked').each(function () {
    var existing_val = bb_form_values['__list_additions'];
    var val = $(this).val();

    if (existing_val) {
      val = existing_val + ',' + val;
    }

    bb_form_values['__list_additions'] = val;
  });
}

function send_bb_form_to_server() {
  $.post('index.php', bb_form_values, function (data) {
    var result = $.parseJSON(data);

    if (typeof grecaptcha !== 'undefined' && grecaptcha) {
      grecaptcha.reset();
    }

    if (result.success == 'true') {
      do_form_success();
    } else {
      show_form_message(result.message, true);
    }
  });
}

function captcha_callback_submit_bb_form(token) {
  bb_form_values['g-recaptcha'] = token;

  submit_bb_form();

  if (typeof grecaptcha !== 'undefined' && grecaptcha) {
    grecaptcha.reset(); // resets gRecaptcha in case the index.php comes back with success = false.
  }
}

function submit_bb_form() {

  show_form_message("", true);
  auto_validate_onchange = true;

  if (!validate_bb_form()) {
    show_form_message("Please fill out all required fields.", false);
    return false;
  }

  if (typeof vidFilename != 'undefined') {
    if (vidFilename != '') {
      submit_recording();
    }
  }

  compile_bb_form_values();
  send_bb_form_to_server();
}

function do_form_success() {
  if (bb_form_success_action == 'r') {
    if ($('#redirLink').attr('target') == '_self') {
      window.location.href = bb_form_redir;
    } else {
      $('#redirLink')[0].click();
    }
  } else {
    $("html, body").animate({ scrollTop: 0 }, "fast");
    $('.form_container').empty();
    $('.form_container').hide();
    $('.form_container').html($('#thankyou_msg').html());
    $('.form_container').fadeIn();
  }
}

var invalid_bb_fields = [];
function validate_bb_form() {
  $('.field_container').removeClass('invalid_field');
  var isFormValid = true;
  invalid_bb_fields = [];

  $(bb_required_field_ids).each(function () {
    var field_id = this;

    var field = $('#' + field_id);

    if ($('#' + field_id).length) {
      var val = $(field).val();

      if (val == '') {
        isFormValid = false;
        invalid_bb_fields.push(field_id);
      }

      if (field_id == 'email') {
        if (!valid_email($(field).val())) {
          isFormValid = false;
          invalid_bb_fields.push(field_id);
        }
      }
    } else {
      //if we didn't find a field by id, it's probably a checkbox or radiobutton, handle those:
      // look for checkboxes
      if ($('input[name="chk_for_' + field_id + '"]').length) {
        if ($('input[name="chk_for_' + field_id + '"]:checked').length == 0) {
          isFormValid = false;
          invalid_bb_fields.push(field_id);
        };
      }

      // look for radio buttons
      if ($('input[name="rb_for_' + field_id + '"]').length) {
        if ($('input[name="rb_for_' + field_id + '"]:checked').length == 0) {
          isFormValid = false;
          invalid_bb_fields.push(field_id);
        };
      }

      if (field_id == '__vidRecorder') {
        if (typeof vidFilename != 'undefined') {
          if (vidFilename == '') {
            alert("Please record a video, or wait for it to finish uploading.");
            isFormValid = false;
            invalid_bb_fields.push(field_id);
          }
        }
      }
    }
  });

  highlight_invalid_fields();

  return isFormValid;
}

function show_form_message(msg, disableSubmitButton) {
  $('.form_message').html(msg);

  if (disableSubmitButton) {
    $('.form_submit_button').removeAttr("disabled");
  } else {
    $('.form_submit_button').attr("disabled", "disabled");
  }
}

function highlight_invalid_fields() {
  $(invalid_bb_fields).each(function () {
    $('.field_container[field_id="' + this + '"]').addClass('invalid_field');
  });
}

function refresh_form_thumb(form_id){
  $.get("/app/api/api.php?method=updateThumbnail&type=form&id=" + form_id);
}

function form_arrival() {
  $(document).ready(function () {
    if (getURLParameter('ol') == 1) {
      window.resizeTo(600,600);
    }

    $('.form_field').each(function (i) {
      var fieldName = this.id;
      var urlVal = getURLParameter(fieldName);
      if (urlVal != 'null') {
        $('#' + fieldName).val(urlVal);
      }
    });
  });
}

function getURLParameter(name) {
  var QueryString = function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!

    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");

    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");

      // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
        query_string[pair[0]] = arr;
      // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }
    return query_string;
  }();

  var result = QueryString[name];
  if (result === undefined) {
    return 'null';
  }

  return result;
}

function prependHTTPtoWebURL(url) {
  if (!url) {
    return url;
  }

  var lcaseUrl = url.toLowerCase();
  if (lcaseUrl.indexOf('http://') == -1 && lcaseUrl.indexOf('https://') == -1) {
    return 'http://' + url;
  }

  return url;
}

$(document).ready(function () {
  var observer = new MutationObserver(function (mutations) {
    for (var i1 = 0; i1 < mutations.length; i1++) {
      var mutation = mutations[i1];
      if (mutation.addedNodes) {
        for (var i2 = 0; i2 < mutation.addedNodes.length; i2++) {
          var node = mutation.addedNodes[i2];

          $('.bb_input_date:not(.hasDatepicker)', node).each(function () {
            $(this).datepicker({
              changeMonth: true,
              changeYear: true,
              yearRange: "c-100:c+10"
            });
          });
        }
      }
    }
  });

  var config = { attributes: false, childList: true, characterData: false, subtree: true };
  observer.observe(document, config);

  $('.bb_input_date:not(.hasDatePicker)').each(function () {
    $(this).datepicker({
      changeMonth: true,
      changeYear: true,
      yearRange: "c-100:c+10"
    });
  });
});
